// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Button_button__ohCoY {
  padding: 11px 16px;
  border-radius: 8px;
  border: 1px solid transparent;
  background: transparent;
  cursor: pointer;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  transition: 0.25s color, 0.25s background, 0.25s border, 0.25s box-shadow;
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
}
.Button_buttonIcon__dj8sK {
  padding: 0;
}
.Button_button__ohCoY:disabled {
  cursor: default;
  pointer-events: none;
}
.Button_button__ohCoY:disabled, .Button_button__ohCoY:hover, .Button_button__ohCoY:active {
  box-shadow: none !important;
}
.Button_button__ohCoY.Button_sizeMedium__Dhcdv {
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
}
.Button_button__ohCoY.Button_sizeSmall__4zEct {
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
}
.Button_button__ohCoY.Button_variantContained__PJ6Uk {
  background: var(--bg);
  color: var(--text);
}
.Button_button__ohCoY.Button_variantSecondary__PetLN {
  background: var(--bg);
  color: var(--text);
}
.Button_button__ohCoY.Button_variantText__Ykoco {
  background: var(--bg);
  color: var(--text);
}
.Button_button__ohCoY.Button_variantOutlined__Qhvs4 {
  background: var(--bg);
  color: var(--text);
  border: 1px solid var(--text);
}
.Button_button__ohCoY.Button_colorPrimary__Ib5M1.Button_variantContained__PJ6Uk {
  --bg: #4778EE;
  --text: white;
  box-shadow: 0px 49px 20px rgba(71, 120, 238, 0.01), 0px 28px 17px rgba(71, 120, 238, 0.05), 0px 12px 12px rgba(71, 120, 238, 0.09), 0px 3px 7px rgba(71, 120, 238, 0.1), 0px 0px 0px rgba(71, 120, 238, 0.1);
}
.Button_button__ohCoY.Button_colorPrimary__Ib5M1.Button_variantContained__PJ6Uk:disabled {
  --bg: #a4c2fc !important;
}
.Button_button__ohCoY.Button_colorPrimary__Ib5M1.Button_variantContained__PJ6Uk:hover {
  --bg: #3667DD;
}
.Button_button__ohCoY.Button_colorPrimary__Ib5M1.Button_variantContained__PJ6Uk:active {
  --bg: #2C5BCC;
}
.Button_button__ohCoY.Button_colorPrimary__Ib5M1.Button_variantSecondary__PetLN {
  --bg: #F7F7F7;
  --text: #272A36;
}
.Button_button__ohCoY.Button_colorPrimary__Ib5M1.Button_variantSecondary__PetLN:disabled {
  --bg: #EDEDED !important;
  --text: #8E8E93 !important;
}
.Button_button__ohCoY.Button_colorPrimary__Ib5M1.Button_variantSecondary__PetLN:hover {
  --bg: #EFEFEF;
}
.Button_button__ohCoY.Button_colorPrimary__Ib5M1.Button_variantSecondary__PetLN:active {
  --bg: #EAEAEA;
}
.Button_button__ohCoY.Button_colorPrimary__Ib5M1.Button_variantText__Ykoco {
  --bg: transparent;
  --text: #4778EE;
}
.Button_button__ohCoY.Button_colorPrimary__Ib5M1.Button_variantText__Ykoco:disabled {
  --text: rgba(71, 120, 238, 0.46) !important;
}
.Button_button__ohCoY.Button_colorPrimary__Ib5M1.Button_variantText__Ykoco:hover {
  --text: #3667DD;
}
.Button_button__ohCoY.Button_colorPrimary__Ib5M1.Button_variantText__Ykoco:active {
  --text: #2C5BCC;
}
.Button_button__ohCoY.Button_colorPrimary__Ib5M1.Button_variantOutlined__Qhvs4 {
  --bg: transparent;
  --text: #4778EE;
}
.Button_button__ohCoY.Button_colorPrimary__Ib5M1.Button_variantOutlined__Qhvs4:disabled {
  --text: rgba(71, 120, 238, 0.46) !important;
}
.Button_button__ohCoY.Button_colorPrimary__Ib5M1.Button_variantOutlined__Qhvs4:hover {
  --text: #3667DD;
}
.Button_button__ohCoY.Button_colorPrimary__Ib5M1.Button_variantOutlined__Qhvs4:active {
  --text: #2C5BCC;
}
.Button_button__ohCoY.Button_colorDanger__gpjd3.Button_variantContained__PJ6Uk {
  --bg: #E23834;
  --text: white;
}
.Button_button__ohCoY.Button_colorDanger__gpjd3.Button_variantContained__PJ6Uk:disabled {
  --bg: #ff9ea0 !important;
}
.Button_button__ohCoY.Button_colorDanger__gpjd3.Button_variantContained__PJ6Uk:hover {
  --bg: #DB3632;
}
.Button_button__ohCoY.Button_colorDanger__gpjd3.Button_variantContained__PJ6Uk:active {
  --bg: #D13430;
}
.Button_button__ohCoY.Button_colorDanger__gpjd3.Button_variantSecondary__PetLN {
  --bg: #F7F7F7;
  --text: #E23834;
}
.Button_button__ohCoY.Button_colorDanger__gpjd3.Button_variantSecondary__PetLN:disabled {
  --bg: #EDEDED !important;
  --text: #F2A3A2 !important;
}
.Button_button__ohCoY.Button_colorDanger__gpjd3.Button_variantSecondary__PetLN:hover {
  --bg: #EFEFEF;
  --text: #DB3632;
}
.Button_button__ohCoY.Button_colorDanger__gpjd3.Button_variantSecondary__PetLN:active {
  --bg: #EAEAEA;
  --text: #D13430;
}
.Button_button__ohCoY.Button_colorDanger__gpjd3.Button_variantText__Ykoco {
  --bg: transparent;
  --text: #E23834;
}
.Button_button__ohCoY.Button_colorDanger__gpjd3.Button_variantText__Ykoco:disabled {
  --text: #F2A3A2 !important;
}
.Button_button__ohCoY.Button_colorDanger__gpjd3.Button_variantText__Ykoco:hover {
  --text: #DB3632;
}
.Button_button__ohCoY.Button_colorDanger__gpjd3.Button_variantText__Ykoco:active {
  --text: #D13430;
}
.Button_button__ohCoY.Button_colorDanger__gpjd3.Button_variantOutlined__Qhvs4 {
  --bg: transparent;
  --text: #E23834;
}
.Button_button__ohCoY.Button_colorDanger__gpjd3.Button_variantOutlined__Qhvs4:disabled {
  --text: #F2A3A2 !important;
}
.Button_button__ohCoY.Button_colorDanger__gpjd3.Button_variantOutlined__Qhvs4:hover {
  --text: #DB3632;
}
.Button_button__ohCoY.Button_colorDanger__gpjd3.Button_variantOutlined__Qhvs4:active {
  --text: #D13430;
}
.Button_button__ohCoY.Button_colorMuted__EQgvV.Button_variantText__Ykoco {
  --bg: transparent;
  --text: #848488;
}
.Button_button__ohCoY.Button_colorMuted__EQgvV.Button_variantText__Ykoco:disabled {
  --text: #cbcbcd !important;
}
.Button_button__ohCoY.Button_colorMuted__EQgvV.Button_variantText__Ykoco:hover {
  --text: #848488;
}
.Button_button__ohCoY.Button_colorMuted__EQgvV.Button_variantText__Ykoco:active {
  --text: #7E7E83;
}`, "",{"version":3,"sources":["webpack://./../../packages/sdk/src/components/ui/buttons/Button/Button.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,kBAAA;EACA,6BAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;KAAA,sBAAA;UAAA,iBAAA;EACA,yEAAA;EACA,sBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;AACF;AACE;EACE,UAAA;AACJ;AAEE;EACE,eAAA;EACA,oBAAA;AAAJ;AAGE;EACE,2BAAA;AADJ;AAKI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AAHN;AAMI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AAJN;AAQE;EACE,qBAAA;EACA,kBAAA;AANJ;AASE;EACE,qBAAA;EACA,kBAAA;AAPJ;AAUE;EACE,qBAAA;EACA,kBAAA;AARJ;AAWE;EACE,qBAAA;EACA,kBAAA;EACA,6BAAA;AATJ;AAaI;EACE,aAAA;EACA,aAAA;EACA,4MAAA;AAXN;AAaM;EACE,wBAAA;AAXR;AAcM;EACE,aAAA;AAZR;AAeM;EACE,aAAA;AAbR;AAiBI;EACE,aAAA;EACA,eAAA;AAfN;AAiBM;EACE,wBAAA;EACA,0BAAA;AAfR;AAkBM;EACE,aAAA;AAhBR;AAmBM;EACE,aAAA;AAjBR;AAqBI;EACE,iBAAA;EACA,eAAA;AAnBN;AAqBM;EACE,2CAAA;AAnBR;AAsBM;EACE,eAAA;AApBR;AAuBM;EACE,eAAA;AArBR;AAyBI;EACE,iBAAA;EACA,eAAA;AAvBN;AAyBM;EACE,2CAAA;AAvBR;AA0BM;EACE,eAAA;AAxBR;AA2BM;EACE,eAAA;AAzBR;AA+BI;EACE,aAAA;EACA,aAAA;AA7BN;AA+BM;EACE,wBAAA;AA7BR;AAgCM;EACE,aAAA;AA9BR;AAiCM;EACE,aAAA;AA/BR;AAmCI;EACE,aAAA;EACA,eAAA;AAjCN;AAmCM;EACE,wBAAA;EACA,0BAAA;AAjCR;AAoCM;EACE,aAAA;EACA,eAAA;AAlCR;AAqCM;EACE,aAAA;EACA,eAAA;AAnCR;AAuCI;EACE,iBAAA;EACA,eAAA;AArCN;AAuCM;EACE,0BAAA;AArCR;AAwCM;EACE,eAAA;AAtCR;AAyCM;EACE,eAAA;AAvCR;AA2CI;EACE,iBAAA;EACA,eAAA;AAzCN;AA2CM;EACE,0BAAA;AAzCR;AA4CM;EACE,eAAA;AA1CR;AA6CM;EACE,eAAA;AA3CR;AAkDI;EACE,iBAAA;EACA,eAAA;AAhDN;AAkDM;EACE,0BAAA;AAhDR;AAmDM;EACE,eAAA;AAjDR;AAoDM;EACE,eAAA;AAlDR","sourcesContent":[".button {\n  padding: 11px 16px;\n  border-radius: 8px;\n  border: 1px solid transparent;\n  background: transparent;\n  cursor: pointer;\n  user-select: none;\n  transition: 0.25s color, 0.25s background, 0.25s border, 0.25s box-shadow;\n  box-sizing: border-box;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  text-decoration: none;\n\n  &Icon {\n    padding: 0;\n  }\n\n  &:disabled {\n    cursor: default;\n    pointer-events: none;\n  }\n\n  &:disabled, &:hover, &:active {\n    box-shadow: none !important;\n  }\n\n  &.size {\n    &Medium {\n      font-weight: 500;\n      font-size: 14px;\n      line-height: 16px;\n    }\n\n    &Small {\n      font-weight: 500;\n      font-size: 12px;\n      line-height: 14px;\n    }\n  }\n\n  &.variantContained {\n    background: var(--bg);\n    color: var(--text);\n  }\n\n  &.variantSecondary {\n    background: var(--bg);\n    color: var(--text);\n  }\n\n  &.variantText {\n    background: var(--bg);\n    color: var(--text);\n  }\n\n  &.variantOutlined {\n    background: var(--bg);\n    color: var(--text);\n    border: 1px solid var(--text);\n  }\n\n  &.colorPrimary {\n    &.variantContained {\n      --bg: #4778EE;\n      --text: white;\n      box-shadow: 0px 49px 20px rgba(71, 120, 238, 0.01), 0px 28px 17px rgba(71, 120, 238, 0.05), 0px 12px 12px rgba(71, 120, 238, 0.09), 0px 3px 7px rgba(71, 120, 238, 0.1), 0px 0px 0px rgba(71, 120, 238, 0.1);\n\n      &:disabled {\n        --bg: #a4c2fc !important;\n      }\n\n      &:hover {\n        --bg: #3667DD;\n      }\n\n      &:active {\n        --bg: #2C5BCC;\n      }\n    }\n\n    &.variantSecondary {\n      --bg: #F7F7F7;\n      --text: #272A36;\n\n      &:disabled {\n        --bg: #EDEDED !important;\n        --text: #8E8E93 !important;\n      }\n\n      &:hover {\n        --bg: #EFEFEF;\n      }\n\n      &:active {\n        --bg: #EAEAEA;\n      }\n    }\n\n    &.variantText {\n      --bg: transparent;\n      --text: #4778EE;\n\n      &:disabled {\n        --text: rgba(71, 120, 238, 0.46) !important;\n      }\n\n      &:hover {\n        --text: #3667DD;\n      }\n\n      &:active {\n        --text: #2C5BCC;\n      }\n    }\n\n    &.variantOutlined {\n      --bg: transparent;\n      --text: #4778EE;\n\n      &:disabled {\n        --text: rgba(71, 120, 238, 0.46) !important;\n      }\n\n      &:hover {\n        --text: #3667DD;\n      }\n\n      &:active {\n        --text: #2C5BCC;\n      }\n    }\n  }\n\n  &.colorDanger {\n    &.variantContained {\n      --bg: #E23834;\n      --text: white;\n\n      &:disabled {\n        --bg: #ff9ea0 !important;\n      }\n\n      &:hover {\n        --bg: #DB3632;\n      }\n\n      &:active {\n        --bg: #D13430;\n      }\n    }\n\n    &.variantSecondary {\n      --bg: #F7F7F7;\n      --text: #E23834;\n\n      &:disabled {\n        --bg: #EDEDED !important;\n        --text: #F2A3A2 !important;\n      }\n\n      &:hover {\n        --bg: #EFEFEF;\n        --text: #DB3632;\n      }\n\n      &:active {\n        --bg: #EAEAEA;\n        --text: #D13430;\n      }\n    }\n\n    &.variantText {\n      --bg: transparent;\n      --text: #E23834;\n\n      &:disabled {\n        --text: #F2A3A2 !important;\n      }\n\n      &:hover {\n        --text: #DB3632;\n      }\n\n      &:active {\n        --text: #D13430;\n      }\n    }\n\n    &.variantOutlined {\n      --bg: transparent;\n      --text: #E23834;\n\n      &:disabled {\n        --text: #F2A3A2 !important;\n      }\n\n      &:hover {\n        --text: #DB3632;\n      }\n\n      &:active {\n        --text: #D13430;\n      }\n    }\n  }\n\n\n  &.colorMuted {\n    &.variantText {\n      --bg: transparent;\n      --text: #848488;\n\n      &:disabled {\n        --text: #cbcbcd !important;\n      }\n\n      &:hover {\n        --text: #848488;\n      }\n\n      &:active {\n        --text: #7E7E83;\n      }\n    }\n  }\n\n  //&.colorMuted {\n  //  &.variantText {\n  //    --bg: transparent;\n  //    --text: #E23834;\n  //\n  //    &:disabled {\n  //      --text: #F2A3A2 !important;\n  //    }\n  //\n  //    &:hover {\n  //      --text: #DB3632;\n  //    }\n  //\n  //    &:active {\n  //      --text: #D13430;\n  //    }\n  //  }\n  //}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `Button_button__ohCoY`,
	"buttonIcon": `Button_buttonIcon__dj8sK`,
	"sizeMedium": `Button_sizeMedium__Dhcdv`,
	"sizeSmall": `Button_sizeSmall__4zEct`,
	"variantContained": `Button_variantContained__PJ6Uk`,
	"variantSecondary": `Button_variantSecondary__PetLN`,
	"variantText": `Button_variantText__Ykoco`,
	"variantOutlined": `Button_variantOutlined__Qhvs4`,
	"colorPrimary": `Button_colorPrimary__Ib5M1`,
	"colorDanger": `Button_colorDanger__gpjd3`,
	"colorMuted": `Button_colorMuted__EQgvV`
};
export default ___CSS_LOADER_EXPORT___;
